import React from 'react';

const Label = ({
  label,
  id,
  textColor,
}: {
  label: string;
  id: string;
  textColor: string;
}) => {
  const labelStyle = `block text-sm font-medium leading-5 w-full ${textColor}`;

  return (
    <label htmlFor={id} className={labelStyle}>
      {label}
    </label>
  );
};

export default Label;

Label.defaultProps = {
  textColor: 'text-sp-neutral',
};
